import { getAPIFromDomain } from "../../lib/api";

export interface CarrierOptions {
  id: string;
  carrier_name: string;
  service_name: string;
}

export const getCarrierOptions = async (): Promise<CarrierOptions[]> => {
  const api = getAPIFromDomain("logistics");
  const url = `/carriers/carriers_to_filter_lookup`;
  const result = await api.get(url);

  return result.data;
};
